












import { Component, Mixins, Prop } from "vue-property-decorator";
import { MenuPane } from "../../../../panes";
import { ModelEditableMixin } from "../../../../system/mixins";

@Component({
  components: {
    MenuPane,
  }
})
export default class TransparentSelector extends Mixins(ModelEditableMixin) {
  @Prop({ default: true })
  isEnable: boolean;

  @Prop({ default: false })
  isHorizontal: boolean;

  get isVisible(): boolean {
    return this.$configuration.behavior.document.editor.contents.edit.selector.transparentSelector.isEnable;
  }
}
